export var TemperatureSettingType;
(function (TemperatureSettingType) {
    TemperatureSettingType["fix"] = "fix";
    TemperatureSettingType["day"] = "day";
    TemperatureSettingType["week"] = "week";
    //Упразднили, т.к.
    // 1. для прошивок <62
    // 2. никто не пользовался
    // pza = 'pza', //4
    TemperatureSettingType["interval"] = "interval";
    TemperatureSettingType["off"] = "off";
    TemperatureSettingType["on_by_request"] = "on_by_request";
    TemperatureSettingType["reserve"] = "reserve";
})(TemperatureSettingType || (TemperatureSettingType = {}));
